// extracted by mini-css-extract-plugin
export default {"twoFaModalBtn":"ResetPassword_twoFaModalBtn__6oc4L","resendBtnImage":"ResetPassword_resendBtnImage__9Z9Qd","modalTitle":"ResetPassword_modalTitle__qc6hx"};